export class LogoHelper {
  static companyLogoUrl(domainName) {
    return `https://logo.clearbit.com/${domainName}`
  }
}
